import WidgetClassFaqModelBase from '../_generated/modelBases/widget-class-faq-model-base';

export default class WidgetClassFaqModel extends WidgetClassFaqModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
